import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import IMG from "@/constants/images";

const serviceImages = [
  IMG.servicePlaster,
  IMG.serviceStucco,
  IMG.serviceSmoothing,
  IMG.serviceRepair,
  IMG.warmHallway,
  IMG.serviceCustom,
];

export default function ServicesPage() {
  const { t } = useI18n();

  return (
    <div data-testid="page-services">
      {/* HEADER */}
      <section className="pt-20 md:pt-28 pb-12 md:pb-20">
        <div className="container-x">
          <div className="eyebrow">— {t.services.eyebrow}</div>
          <h1 className="mt-6 text-[clamp(2.5rem,6vw,5.5rem)] leading-[1.02] tracking-[-0.02em] max-w-4xl">
            {t.services.title}
          </h1>
          <p className="mt-8 max-w-2xl text-lg leading-relaxed text-[hsl(var(--ink-soft))]">
            {t.services.lead}
          </p>
        </div>
      </section>

      {/* SERVICE LIST */}
      <section className="container-x pb-24">
        <div className="border-t border-[hsl(var(--line))]">
          {t.services.list.map((s, i) => (
            <div
              key={i}
              data-testid={`service-row-${i}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-12 md:py-16 border-b border-[hsl(var(--line))] items-center"
            >
              <div className="md:col-span-1">
                <div className="stat-num text-2xl md:text-3xl text-[hsl(var(--ocre-deep))]">
                  0{i + 1}
                </div>
              </div>
              <div className="md:col-span-4">
                <h2 className="text-2xl md:text-4xl leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {s.title}
                </h2>
              </div>
              <div className="md:col-span-4 text-[hsl(var(--ink-soft))] leading-relaxed">
                {s.body}
              </div>
              <div className="md:col-span-3">
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={serviceImages[i]}
                    alt=""
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-[1.4s] group-hover:scale-105"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CLOSING CTA */}
      <section className="bg-[hsl(var(--bg-elev))] py-24 md:py-32">
        <div className="container-x grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <h2 className="text-3xl md:text-5xl leading-[1.05]">
              {t.services.closeTitle}
            </h2>
            <p className="mt-6 text-[hsl(var(--ink-soft))] text-lg max-w-xl">
              {t.services.closeBody}
            </p>
          </div>
          <div className="md:col-span-5 md:text-right">
            <Link to="/contact" className="btn-primary" data-testid="services-cta-quote">
              {t.home.ctaPrimary} <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
